import React, { useState } from "react";
import { Plus } from "lucide-react";
import { CARD } from "@/styles/shared";

export default function QuickAdd({ onAdd }) {
  const [input, setInput] = useState("");
  const [adding, setAdding] = useState(false);

  const handleSubmit = async () => {
    const title = input.trim();
    if (!title || adding) return;
    setAdding(true);
    try {
      await onAdd(title);
      setInput("");
    } finally {
      setAdding(false);
    }
  };

  return (
    <div data-testid="quick-add-card" style={{ ...CARD, width: "100%", maxWidth: "640px", padding: "0.75rem" }}>
      <div style={{ display: "flex", gap: "0.625rem" }}>
        <input
          data-testid="task-input"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
          placeholder="Quick add task… (Enter)"
          style={{
            flex: 1,
            background: "rgba(255, 255, 255, 0.20)",
            border: "1px solid rgba(26,77,46,0.2)",
            borderRadius: "0.5rem",
            padding: "0.6rem 0.875rem",
            color: "#0F172A",
            fontSize: "0.9rem",
            fontFamily: "'Manrope', sans-serif",
            outline: "none",
            transition: "border-color 0.2s",
          }}
          onFocus={(e) => (e.target.style.borderColor = "#3d6b1f")}
          onBlur={(e) => (e.target.style.borderColor = "rgba(26,77,46,0.2)")}
        />
        <button
          data-testid="add-task-btn"
          onClick={handleSubmit}
          disabled={adding || !input.trim()}
          style={{
            display: "flex", alignItems: "center", gap: "0.3rem",
            padding: "0.6rem 1.1rem",
            borderRadius: "0.5rem",
            background: input.trim() ? "#3d6b1f" : "rgba(61,107,31,0.4)",
            border: "none", color: "#fff",
            fontSize: "0.875rem", fontWeight: 600,
            fontFamily: "'Manrope', sans-serif",
            cursor: input.trim() ? "pointer" : "not-allowed",
            transition: "background 0.2s",
            whiteSpace: "nowrap",
          }}
          onMouseEnter={(e) => { if (input.trim()) e.currentTarget.style.background = "#4a7f25"; }}
          onMouseLeave={(e) => { if (input.trim()) e.currentTarget.style.background = "#3d6b1f"; }}
        >
          <Plus size={15} /> Add
        </button>
      </div>
    </div>
  );
}
